import { useAuth } from '@/hooks/useAuth';
import { User } from '@/types/api/user';
import { getAvatar } from '@/utils/helper';
import Avatar from '../Avatar';
import { Dropdown, DropdownTrigger, DropdownMenu, DropdownItem, Button } from '@nextui-org/react';
import Image from 'next/image';
import { useState } from 'react';
import AccountSettingModal from '@/components/AccountSettingModal';
import { DotsThreeOutlineVertical, GearSix } from '@phosphor-icons/react';

const UserComponent = ({ user, subField, isShowToggle }: { user?: User; subField?: string, isShowToggle?: boolean }) => {
  const { session, logout } = useAuth();
  const [isAccountSettingModalOpen, setIsAccountSettingModalOpen] = useState(false);

  const userData = user ?? session?.user;

  const handleLogout = async () => {
    await logout();
  };

  return (
    <div className="flex items-center justify-between">
      <div className='flex items-center gap-2 cursor-pointer' onClick={() => setIsAccountSettingModalOpen(true)}>
        <Avatar src={userData?.avatar ? userData?.avatar : getAvatar(userData?.id)} />
        <div>
          <p className='font-semibold'>{userData?.name}</p>
          <p className='text-sm text-gray-500 max-w-[140px] break-words limit-1-line'>
            {subField ?? userData?.email}
          </p>
        </div>
      </div>

      {isShowToggle && <Dropdown placement="bottom-end">
        <DropdownTrigger>
          <Button isIconOnly variant="light" className="ml-2">
            <DotsThreeOutlineVertical size={16} weight='fill' />
          </Button>
        </DropdownTrigger>
        <DropdownMenu aria-label="Profile Actions" variant="flat">
          <DropdownItem
            key="account-setting"
            onClick={() => setIsAccountSettingModalOpen(true)}
            startContent={
              <GearSix size={24} />
            }
          >
            Account Setting
          </DropdownItem>
          <DropdownItem
            key="logout"
            onClick={handleLogout}
            startContent={
              <Image src='/assets/icons/logout.svg' alt='logout' width={24} height={24} />
            }
          >
            Logout
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>}

      {isAccountSettingModalOpen && (
        <AccountSettingModal
          isOpen={isAccountSettingModalOpen}
          onClose={() => setIsAccountSettingModalOpen(false)}
        />
      )}
    </div>
  );
};

export default UserComponent;
